import { postData} from "adminApi/apiClient";


export const createNewCustomer = async ({ data }) => {
  try {
    const result = await postData(`/booking-customer/create-customer`,
      data,
      {
        "Content-Type": "multipart/form-data",
      },
    );
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Create New Customer API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

export const createNewGuest = async ({ data }) => {
  try {
    const result = await postData(`/booking-customer/create-guest`,
      data,
      {
        "Content-Type": "multipart/form-data",
      },
    );
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Create New Customer API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};


